var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 52.9231H496V16H16V52.9231V52.9231Z",
    fill: "#B22234"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 89.8459H496V52.9229H16V89.8459V89.8459Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 126.769H496V89.8457H16V126.769V126.769Z",
    fill: "#B22234"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 163.692H496V126.769H16V163.692V163.692Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 200.615H496V163.692H16V200.615V200.615Z",
    fill: "#B22234"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 237.538H496V200.615H16V237.538V237.538Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 274.461H496V237.538H16V274.461V274.461Z",
    fill: "#B22234"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 311.384H496V274.461H16V311.384V311.384Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 348.308H496V311.385H16V348.308V348.308Z",
    fill: "#B22234"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16 385.231H496V348.308H16V385.231V385.231Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16 422.154H496V385.23H16V422.154V422.154Z",
    fill: "#B22234"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 459.076H496V422.153H16V459.076V459.076Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16 496H496V459.077H16V496V496Z",
    fill: "#B22234"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M275 16H16V275H275V16Z",
    fill: "#3C3B6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.56e529d553e37369356e84d885e35e13.svg";
export { ForwardRef as ReactComponent };